import { Injectable } from '@angular/core'
import chroma from 'chroma-js'
import { BehaviorSubject, Observable } from 'rxjs';
import { ChartValueColor } from '../../interfaces/color-dimension-values.interface';

@Injectable()
export class ColorService {
  private chartValueColorsMap: Map<string, ChartValueColor[]> = new Map();
  private chartValueColorsMapSubject: BehaviorSubject<Map<string, ChartValueColor[]>> = new BehaviorSubject(this.chartValueColorsMap);

  defaultColors = [
    '#7051FE',
    '#1FD8BC',
    '#E440AB',
    '#F16A42',
    '#A540F1',
    '#F6B340',
    '#298FEE',
    '#F6E137',
    '#5AD21D',
    '#F4425B',
    '#4B349E',
    '#0C9A84',
    '#A62378',
    '#C14620',
    '#682D94',
    '#BE841C',
    '#1F6BB3',
    '#B5A205',
    '#37910A',
    '#BE2137'
  ]

  getSimilarColorSeries(baseColor, num) {
    if (num === 1) {
      return [baseColor]
    }
    const base = chroma(baseColor)
    const luminance = base.luminance()

    const amount = 8
    const dark = base.darken(amount).saturate(amount)
    const light = base.brighten(amount)

    const correction = 0.5 + (luminance - 0.5) / 4
    const padding = Math.max((0.15 - 0.00005 * Math.pow(num, 2)) - 0.0005 * num, 0.1)

    return chroma
      .scale([dark, baseColor, light])
      .domain([0, correction, 1])
      .padding([padding, padding])
      .colors(num)
      .reverse()
  }

  getScale(colors=[]) {
    return chroma.scale(colors)
  }

  public setChartValueColors(widgetId: string, colors: ChartValueColor[]): void {
    this.chartValueColorsMap.set(widgetId, colors);
    this.chartValueColorsMapSubject.next(this.chartValueColorsMap);
  }

  public getChartValuesColors(widgetId: string): ChartValueColor[] | undefined {
    return this.chartValueColorsMap.get(widgetId);
  }

  public getChartValuesColorMap$(): Observable<Map<string, ChartValueColor[]>> {
    return this.chartValueColorsMapSubject.asObservable();
  }
}
